import { WEBHOOKSTATUS } from "../api/constApi";
import { apiInstance } from "./axiosApi";

export const webhookStatus = (payload) => {
  return apiInstance.post(WEBHOOKSTATUS, payload);
};
